import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import productService from "./productService";

export const getProducts = createAsyncThunk(
  "product/all",
  async (thunkAPI) => {
    try {
      return await productService.getProducts();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// export const createProducts = createAsyncThunk(
//   "product/add",
//   async (productData, thunkAPI) => {
//     try {
//       return await productService.createProduct(productData);
//     } catch (error) {
//       // return thunkAPI.rejectWithValue(error);
//       const message =
//       (error.response && error.response.data && error.response.data.message) ||
//       error.message ||
//       error.toString();
//     return thunkAPI.rejectWithValue(message);
//     }
//   }
// );

export const createProducts = createAsyncThunk(
  "product/add",
  async (productData, thunkAPI) => {
    try {
      return await productService.createProduct(productData);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAProduct = createAsyncThunk(
  "product/show",
  async (id, thunkAPI) => {
    try {
      return await productService.getProduct(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// export const updateAProduct = createAsyncThunk(
//   "product/edit",
//   async (product, thunkAPI) => {
//     try {
//       return await productService.updateProduct(product);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

export const updateAProduct = createAsyncThunk(
  "product/edit",
  async (product, thunkAPI) => {
    try {
      return await productService.updateProduct(product.id, product.products);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteAProduct = createAsyncThunk(
  "product/delete",
  async (id, thunkAPI) => {
    try {
      return await productService.deleteProduct(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  products: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    deleteProductImage: (state, action) => {
      state.productImages = state.productImages.filter((img) => img !== action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.products = action.payload.data;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(createProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdProduct = action.payload;
      })
      .addCase(createProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload || action.error?.message || "Something went wrong";
      })
      .addCase(getAProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAProduct.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        const product = action.payload;
        state.id = product._id;
        state.averageRating = product.averageRating || 0;
        state.productName = product.product_name || "";

        state.price = product.price || 0;
        state.priceType = product.price_is_fixed || false;

        state.aboutProduct = product.about_this_item || "";
        state.categoryId = product.category?._id || "";
        state.status = product.status || "";

        state.metalName = product.metal_type?.metal_name || "";
        state.metalId = product.metal_type?._id || "";

        state.promoType = product.promo_type?.promotype_name || "";
        state.promoId = product.promo_type?._id || "";

        state.gender = product.gender || "";
        state.weight = product.weight || 0;
        state.height = product.height || 0;
        state.width = product.width || 0;
        state.gross_weight = product.gross_weight || "";
        state.net_weight = product.net_weight || "";
        state.pcs = product.pcs || "";
        state.wastage = product.wastage || "";
        state.size = product.size || "";

        state.makingCharge = product.making_charges_per_gm || 0;
        state.makingType = product.making_type || "";

        state.hallMark = product.hall_mark_charges || "";
        state.additionalCharges = product.additional_charges || 0;

        state.designCode = product.design_code || "";
        state.productImages = product.product_images || [];

        state.discountType = product.discount_type || "";
        state.discount = product.discount || 0;

        state.PurityId = product.purity?._id || "";
        state.productPurity = product.purity?.product_purity || "";

        state.colorId = product.color?.map(c => c._id);  
        state.colorName = product.color?.map(c => c.color_name);
        state.show_price = product.show_price !== undefined ? product.show_price : true;
      })
      .addCase(getAProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAProduct.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedProduct = action.payload;
      })
      .addCase(updateAProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload || action.error?.message || "Something went wrong";
      })
      .addCase(deleteAProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAProduct.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedProduct = action.payload;
      })
      .addCase(deleteAProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default productSlice.reducer;
export const { deleteProductImage } = productSlice.actions;
